import React, { useState, useEffect, useContext } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import homepicture from "./pages/Images/homepicture.png";
import homepicture2 from "./pages/Images/homepicture2.png";
import supplypic from "./pages/Images/supplypic.png";
import supplypic2 from "./pages/Images/supplypic2.png";
import supplypicture from "./pages/Images/supplypicture.png";
import supplypicture2 from "./pages/Images/supplypicture2.png";
import changepricepicture from "./pages/Images/changepricepicture.png";
import changepricepicture2 from "./pages/Images/changepricepicture2.png";
import salespicture from "./pages/Images/salespicture.png";
import salespicture2 from "./pages/Images/salespicture2.png";
import accountpicture from "./pages/Images/accountpicture.png";
import accountpicture2 from "./pages/Images/accountpicture2.png";
import myreportpicture from "./pages/Images/myreportpicture.png";
import myreportpicture2 from "./pages/Images/myreportpicture2.png";
import passwordpicture from "./pages/Images/passwordpicture.png";
import passwordpicture2 from "./pages/Images/passwordpicture2.png";
import inventorypicture from "./pages/Images/inventorypicture.png";
import inventorypicture2 from "./pages/Images/inventorypicture2.png";
import adminpicture from "./pages/Images/adminpicture.png";
import adminpicture2 from "./pages/Images/adminpicture2.png";
import newuserpicture from "./pages/Images/newuserpicture.png";
import newuserpicture2 from "./pages/Images/newuserpicture2.png";
import viewuserpicture from "./pages/Images/viewuserpicture.png";
import viewuserpicture2 from "./pages/Images/viewuserpicture2.png";
import viewdebtpicture from "./pages/Images/viewdebtpicture.png";
import viewdebtpicture2 from "./pages/Images/viewdebtpicture2.png";
import PermissionContext from ".././Store/permission-context";
import historypicture from "./pages/Images/historypicture.png";
import historypicture2 from "./pages/Images/historypicture2.png";
import backuppicture from "./pages/Images/backuppicture.png";
import backuppicture2 from "./pages/Images/backuppicture2.png";
import salesreportpicture from "./pages/Images/salesreportpicture.png";
import salesreportpicture2 from "./pages/Images/salesreportpicture2.png";
import supplyreportpicture from "./pages/Images/supplyreportpicture.png";
import supplyreportpicture2 from "./pages/Images/supplyreportpicture2.png";
import logoutpicture from "./pages/Images/logoutpicture.png";
import logoutpicture2 from "./pages/Images/logoutpicture2.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/fontawesome-free-solid";
import Cookies from "universal-cookie";
import classes from "./MenuComponent.module.css";
import Dropdown from "./Dropdown";

const MenuComponent = (props) => {
  const cookies = new Cookies();
  var CryptoJS = require("crypto-js");
  const PCtx = useContext(PermissionContext);
  const [TheTime, setTheTime] = useState("00:00:00");

  const [Menus, setMenus] = useState([
    {
      title: "Home",
      path: "/fazaarstore",
      picture: homepicture,
      hoverpicture: homepicture2,
      HasMouseEntered: false,
    },

    {
      title: "Supply",
      dropitdown: false,
      picture: supplypic,
      hoverpicture: supplypic2,
      HasMouseEntered: false,
      submenu: [
        {
          title: "Supply-In",
          path: PCtx.ThePath + "/#",
          picture: supplypicture,
          hoverpicture: supplypicture2,
          HasMouseEntered: false,
        },
        {
          title: "Change Price",
          path: PCtx.ThePath + "/#",
          picture: changepricepicture,
          hoverpicture: changepricepicture2,
          HasMouseEntered: false,
        },
      ],
    },
    {
      title: "Sales",
      path: PCtx.ThePath + "/#",
      picture: salespicture,
      hoverpicture: salespicture2,
      HasMouseEntered: false,
    },
    {
      title: "My Account",
      dropitdown: false,
      picture: accountpicture,
      hoverpicture: accountpicture2,
      HasMouseEntered: false,
      submenu: [
        {
          title: "My Report",
          path: PCtx.ThePath + "/#",
          picture: myreportpicture,
          hoverpicture: myreportpicture2,
          HasMouseEntered: false,
        },
        {
          title: "Change My Password",
          path: PCtx.ThePath + "/#",
          picture: passwordpicture,
          hoverpicture: passwordpicture2,
          HasMouseEntered: false,
        },
      ],
    },
    {
      title: "Inventory",
      path: PCtx.ThePath + "/#",
      picture: inventorypicture,
      hoverpicture: inventorypicture2,
      HasMouseEntered: false,
    },
    {
      title: "Admin",
      dropitdown: false,
      picture: adminpicture,
      hoverpicture: adminpicture2,
      HasMouseEntered: false,
      submenu: [
        {
          title: "Add New Staff/Customer",
          path: PCtx.ThePath + "/#",
          picture: newuserpicture,
          hoverpicture: newuserpicture2,
          HasMouseEntered: false,
        },
        {
          title: "View Staff",
          path: PCtx.ThePath + "/#",
          picture: viewuserpicture,
          hoverpicture: viewuserpicture2,
          HasMouseEntered: false,
        },
        {
          title: "Get Sales Report",
          path: PCtx.ThePath + "/#",
          picture: salesreportpicture,
          hoverpicture: salesreportpicture2,
          HasMouseEntered: false,
        },
        {
          title: "Get Supply Report",
          path: PCtx.ThePath + "/#",
          picture: supplyreportpicture,
          hoverpicture: supplyreportpicture2,
          HasMouseEntered: false,
        },
        {
          title: "View All Debts",
          path: PCtx.ThePath + "/#",
          picture: viewdebtpicture,
          hoverpicture: viewdebtpicture2,
          HasMouseEntered: false,
        },
        {
          title: "Cash Flow",
          path: PCtx.ThePath + "/#",
          picture: viewdebtpicture,
          hoverpicture: viewdebtpicture2,
          HasMouseEntered: false,
        },
        {
          title: "Get Item History",
          path: PCtx.ThePath + "/#",
          picture: historypicture,
          hoverpicture: historypicture2,
          HasMouseEntered: false,
        },
        {
          title: "Back - up",
          path: "/backup",
          picture: backuppicture,
          hoverpicture: backuppicture2,
          HasMouseEntered: false,
        },
        {
          title: "Update ",
          path: "/updateonline",
          picture: backuppicture,
          hoverpicture: backuppicture2,
          HasMouseEntered: false,
        },
      ],
    },
    {
      title: "Log Out",
      path: "/",
      picture: logoutpicture,
      hoverpicture: logoutpicture2,
      HasMouseEntered: false,
    },
  ]);

  useEffect(() => {
    if (PCtx.logged) {
      setMenus(PCtx.Menus);
    }
  }, [PCtx.Menus]);

  const clockUpdate = () => {
    var date = new Date();
    function addZero(x) {
      if (x < 10) {
        return (x = "0" + x);
      } else {
        return x;
      }
    }

    function twelveHour(x) {
      if (x > 12) {
        return (x = x - 12);
      } else if (x == 0) {
        return (x = 12);
      } else {
        return x;
      }
    }

    var h = addZero(twelveHour(date.getHours()));
    var m = addZero(date.getMinutes());
    var s = addZero(date.getSeconds());
    setTheTime(h + ":" + m + ":" + s);
    // setisVisible(!isVisible);
  };

  setInterval(clockUpdate, 1000);

  const setMyDropDown = (ind, value) => {
    let Mn = [...Menus];
    let submn = { ...Mn[ind] };
    submn.dropitdown = value;
    submn.HasMouseEntered = value;
    Mn[ind] = submn;
    setMenus(Mn);
  };

  const DontFollowLink = () => {
    PCtx.displayAlert(
      "Oops",
      "You have been logged out. Please login to continue",
      "danger",
    );
  };

  const checkValidity = (mnu) => {
    if (mnu.location === "unaccessible") {
      PCtx.displayAlert(
        "ACTION DENIED",
        "You are not authorised for this Menu. Contact the Administrator",
        "danger",
      );
    }
  };

  const LogMeOut = () => {
    cookies.remove("logged", { path: "/" });
    cookies.remove("this_staff", { path: "/" });
    cookies.remove("NS", { path: "/" });
    cookies.remove("MR", { path: "/" });
    cookies.remove("SI", { path: "/" });
    cookies.remove("CP", { path: "/" });
    cookies.remove("ASt", { path: "/" });
    cookies.remove("VS", { path: "/" });
    cookies.remove("CPw", { path: "/" });
    cookies.remove("SP", { path: "/" });
    cookies.remove("SR", { path: "/" });
    cookies.remove("IV", { path: "/" });
    cookies.remove("VD", { path: "/" });
    cookies.remove("GH", { path: "/" });
    cookies.remove("ExpiredItems", { path: "/" });
    PCtx.GetCookiesValue();
    window.location.pathname = "/" + PCtx.ThePath;
    PCtx.displayAlert(
      "Logged Out",
      "You have been successfully logged out. Bye!",
      "success",
    );
  };

  return (
    <ul
      className={props.isM ? classes.nav_ul_style_hide : classes.nav_ul_style}
    >
      {Menus.map((themenu, index) =>
        themenu.submenu ? (
          <li
            key={index}
            className={classes.nav_ul_li_drop_style}
            onMouseEnter={() => setMyDropDown(index, true)}
            onMouseLeave={() => setMyDropDown(index, false)}
            onClick={() => setMyDropDown(index, !themenu.dropitdown)}
          >
            <Link
              to="#"
              className={
                themenu.dropitdown ? classes.nav_links_hover : classes.nav_links
              }
            >
              <span>
                <img
                  src={
                    themenu.HasMouseEntered
                      ? themenu.hoverpicture
                      : themenu.picture
                  }
                  className={classes.menuPix}
                />
              </span>
              {themenu.title} <FontAwesomeIcon icon={faCaretDown} />
            </Link>

            {themenu.dropitdown && (
              <Dropdown submenu={themenu.submenu} Clicker={checkValidity} />
            )}
          </li>
        ) : (
          <li
            key={index}
            className={classes.nav_ul_li_style}
            onMouseEnter={() => setMyDropDown(index, true)}
            onMouseLeave={() => setMyDropDown(index, false)}
          >
            {PCtx.logged ? (
              themenu.title != "Log Out" ? (
                <Link
                  to={themenu.path}
                  onClick={() => checkValidity(themenu.path)}
                  className={classes.nav_links}
                >
                  <span>
                    <img
                      src={
                        themenu.HasMouseEntered
                          ? themenu.hoverpicture
                          : themenu.picture
                      }
                      className={classes.menuPix}
                    />
                  </span>
                  {themenu.title}
                </Link>
              ) : (
                <Link onClick={LogMeOut} className={classes.nav_links}>
                  {themenu.title}
                </Link>
              )
            ) : (
              <Link
                to="#"
                className={classes.nav_links}
                onClick={DontFollowLink}
              >
                <span>
                  <img
                    src={
                      themenu.HasMouseEntered
                        ? themenu.hoverpicture
                        : themenu.picture
                    }
                    className={classes.menuPix}
                  />
                </span>
                {themenu.title}
              </Link>
            )}
          </li>
        ),
      )}

      <li className={classes.nav_ul_li_style}>
        <Button variant="outline-primary" className={classes.signUp}>
          {TheTime}
        </Button>
      </li>
    </ul>
  );
};

export default MenuComponent;
